import { render, staticRenderFns } from "./bookshelf.vue?vue&type=template&id=9b3b7840&scoped=true&"
import script from "./bookshelf.vue?vue&type=script&lang=js&"
export * from "./bookshelf.vue?vue&type=script&lang=js&"
import style0 from "./bookshelf.vue?vue&type=style&index=0&id=9b3b7840&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3b7840",
  null
  
)

component.options.__file = "bookshelf.vue"
export default component.exports